import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { MotionConfig } from 'motion/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import './styles/theme.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A household's receipts change rarely; refetching on every window focus
      // would be pure noise on a phone that is constantly being picked up.
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      retry: (failureCount, error) => {
        // Never retry an auth failure — it will not start working.
        const status = (error as { status?: number }).status;
        if (status === 401 || status === 403) return false;
        return failureCount < 2;
      },
    },
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/*
        The CSS reduced-motion rule only reaches CSS transitions; every panel
        and sheet here is animated in JavaScript and kept moving straight
        through it. `reducedMotion="user"` holds those to opacity alone when
        the system asks for less movement.
      */}
      <MotionConfig reducedMotion="user">
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MotionConfig>
    </QueryClientProvider>
  </StrictMode>,
);
